const DonationCampaignTypes = {
  FestiveBauble: 'Festive Bauble',
  GiftCard: 'Gift Card',
  RegularDonation: 'Regular Donation',
  ProductList: 'Product List',
  InnovationFund: 'Innovation Fund',
} as const;

export type DonationCampaignType =
  (typeof DonationCampaignTypes)[keyof typeof DonationCampaignTypes];

export default DonationCampaignTypes;
